import { useEffect, useState } from "react";

const FRONT_IFRAME_ID = "front-chat-iframe";
const POLL_INTERVAL_MS = 1000;

/**
 * Reactive flag for whether Encamp's Front support iframe is mounted in the
 * DOM. Polls because Front injects its iframe asynchronously after its
 * bundle loads (see `apps/oak/src/components/FrontChat.tsx`) — there's no
 * synchronous lifecycle hook we can attach to.
 *
 * The Scout launcher uses this to slide right and make room for Front when
 * Front is present, and to take Front's spot otherwise.
 */
export function useFrontChatPresent(): boolean {
  const [present, setPresent] = useState<boolean>(() =>
    typeof document === "undefined" ? false : Boolean(document.getElementById(FRONT_IFRAME_ID))
  );

  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    // No initial call: useState's lazy initializer already captured presence
    // at first render. The interval picks up any change after that (Front
    // mounts the iframe ~asynchronously after its bundle loads).
    const interval = setInterval(() => {
      setPresent(Boolean(document.getElementById(FRONT_IFRAME_ID)));
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return present;
}
